angular.module('impactx.suppliercatalogupload').controller('CatalogUploadCtrl', [
    '$scope',
    'dataGen',
    '$redirect',
    '$mdToast',
    'CatalogImportService',
    '$routeParams',
    '$securityManager',
    'AppConfiguration',
    'ToolbarService',
    CatalogUploadCtrl]);

function CatalogUploadCtrl($scope, dataGen, $redirect, $mdToast, CatalogImportService, $routeParams, $securityManager, AppConfiguration, ToolbarService) {
    var self = this;
    self.hideImportDateType = false;
    $scope.testDate = {};
    $scope.uploadCatalog = {};
    $scope.uploadMultimedia = {};
    $scope.wizardIndex = 0;
    $scope.uploadStarted = {value: false};

    dataGen.getData($scope, {replaceCatId: $routeParams.replaceCatId}, "/catalog/supplierupload").then(function () {
        $scope.supplierLabel = $scope.data.supplier.label;
        self.hideImportDateType = AppConfiguration.get('hideDelayedCatalogImportForSupplier') && $scope.data.isSupplier;
        ToolbarService.setButtons([]);
    });

    self.uploadCatalog = function (event) {
        $scope.uploadStarted.value = true;

        var catalogFormData = {
            catalogFile: $scope.uploadCatalog.file,
            catalogFileName: $scope.uploadCatalog.file.name,
            supplierId: $scope.data.supplier && $scope.data.supplier.selected && $scope.data.supplier.selected.id ? $scope.data.supplier.selected.id : 0,
            replaceCatId: $routeParams.replaceCatId ? $routeParams.replaceCatId : 0,
        };

        if ($scope.uploadMultimedia.file) {
            catalogFormData.mmdFile = $scope.uploadMultimedia.file;
            catalogFormData.mmdFileName = $scope.uploadMultimedia.file.name;
        }
        else if ($scope.data.mmdPath && $scope.data.mmdPath.value) {
            catalogFormData.mmdPath = $scope.data.mmdPath.value;
        }
        dataGen.uploadFile(catalogFormData, '/catalog/supplieruploadstore').then(function (response) {
            $scope.uploadStarted.value = false;
            $scope.wizardIndex = 1;
            $scope.data = response.data;
            $scope.trns = response.trns;
            self.importCatalog(event);
        }, function () {
            $scope.uploadStarted.value = false
        });
    };

    self.importCatalog = function (event) {
        var callBackFunc = function (statusMessage) {
            $redirect.redirectTo(null, "/cataloglist"+($routeParams.replaceCatId ? "/"+$routeParams.replaceCatId : ""));
            $mdToast.show(
                $mdToast.simple()
                    .textContent(statusMessage)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        };
        CatalogImportService.showCatalogImportDialogPreSetData(callBackFunc, event, $scope.data, $scope.trns, self.hideImportDateType);
    };
}